import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { TextField, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import routes from "routes";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function SignInBasic() {
  const [emailErrorMessage, setEmailErrorMessage] = useState('');

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleEmailChange = (e) => {
    const enteredValue = e.target.value;
    setEmail(enteredValue);
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enteredValue);
    if (isValidEmail) {
      setEmail(enteredValue);
    }
  };

  const handleSubmitClick = () => {
    setLoading(true);
    console.log(email);
    fetch(`${process.env.REACT_APP_API_URL}/api/verifyuseremail/${email}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data.Message);
        if (data.Message === "Email does not verified") {
          setEmailErrorMessage('Almost there! To proceed with the login process, please verify your email address. Check your inbox for the confirmation link!');
        } else if (data.Message === "User does not found") {
          setEmailErrorMessage('Email Id entered is not registered with us');
        } else if (data.Message === "Email verified") {
          login();
        } else {
          setEmailErrorMessage('Something Went Wrong');
        }
        console.log("hi");
        setLoading(false);
      })
      .catch((error) => {
        console.log("hi11111");
        console.error(error);
        setEmailErrorMessage(error);
        setLoading(false);
      });
  }

  const navigate = useNavigate();
  const location = useLocation();

  const login = () => {
    const redirectUrl = location.state?.redirectUrl || '/app/trainingcompanydashboard/';
    const login = {
      email: email,
      password: password,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login),
    })
      .then((response) => response.json())
      .then((data) => {
        setPassword("");
        if (data.tokens && data.email && data.username) {
          console.log(data);
          localStorage.setItem("userId", data.id);
          localStorage.setItem("user", data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("number", data.mobile_number);
          localStorage.setItem("token", data.tokens.access);
          localStorage.setItem("mobile", data.is_verified_mobile);
          localStorage.setItem("verified", data.is_verified);
          localStorage.setItem("verified_tc", data.is_verified_tc);
          localStorage.setItem("group", data.groups[0]);

          let tc_status = localStorage.getItem("verified_tc");
          let mobile_status = localStorage.getItem("mobile");
          if (JSON.parse(tc_status) === false) {
            navigate(redirectUrl);
          } else if (JSON.parse(mobile_status) === false) {
            navigate(redirectUrl);
          } else {
            navigate(redirectUrl);
          }
        } else {
          setEmailErrorMessage(data.detail);
        }
      })
      .catch((error) => {
        console.error(error);
        setEmailErrorMessage(error);
      });
  };

  const googleButton = useRef(null);

  useEffect(() => {
    const src = 'https://accounts.google.com/gsi/client';

    const CLIENT_ID = `${process.env.REACT_APP_CLIENTID}`;

    loadScript(src)
      .then(() => {
        /*global google*/
        google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: handleCredentialResponse,
        });
        google.accounts.id.renderButton(googleButton.current, {
          theme: 'outline',
          size: 'large',
        });
      })
      .catch(console.error);

    return () => {
      const scriptTag = document.querySelector(`script[src="${src}"]`);
      if (scriptTag) document.body.removeChild(scriptTag);
    };
  }, [loading]);

  function handleCredentialResponse(response) {
    const redirectUrl = location.state?.redirectUrl || '/app/trainingcompanydashboard/';
    if (response.credential) {
      var data = { groups: "1", auth_token: response.credential };
      let authstatus = "login";
      fetch(`${process.env.REACT_APP_API_URL}/api/google/${authstatus}`, {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (res && res[0]) {
            setEmailErrorMessage(res[0]);
          } else {
            let email = res['email'];
            let token = res['tokens'];
            let access_token = token.access;
            let user_id = res["user_id"];
            let username = res["username"];
            let is_verified = res["is_verified"];
            let is_verified_tc = res["is_verified_tc"];
            let groups = res["groups"];
            console.log("groups", groups);

            localStorage.setItem("userId", user_id);
            localStorage.setItem("user", username);
            localStorage.setItem("verified", is_verified);
            localStorage.setItem("verified_tc", is_verified_tc);
            localStorage.setItem("email", email);
            localStorage.setItem("token", access_token);
            localStorage.setItem("group", groups);

            let tc_status = localStorage.getItem("verified_tc");
            let mobile_status = localStorage.getItem("mobile");
            if (JSON.parse(tc_status) === false) {
              navigate(redirectUrl);
            } else if (JSON.parse(mobile_status) === false) {
              navigate(redirectUrl);
            } else {
              navigate(redirectUrl);
            }
          }
        })
        .catch((error) => {
          setEmailErrorMessage(error);
          console.log('error', error);
          setLoading(false);
        });
    }
  }

  console.log("email", localStorage.getItem("email"));
  console.log("token", localStorage.getItem("token"));
  console.log("group", localStorage.getItem("group"));

  return (
    <>
      <LoadingOverlay loading={loading}>
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <MKBox
          position="absolute"
          top={0}
          left={0}
          zIndex={1}
          width="100%"
          minHeight="100vh"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
          <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
            <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  mx={2}
                  mt={-3}
                  p={2}
                  mb={1}
                  textAlign="center"
                >
                  <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    Sign in as Training Partner
                  </MKTypography>
                  <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                    <div id='google-login-btn'>
                      <div ref={googleButton} id='google-ref'></div>

                    </div>
                  </Grid>
                </MKBox>
                <MKBox pt={4} pb={3} px={3}>
                  <MKBox component="form" role="form">
                    <MKBox mb={2}>
                      <MKInput type="email" label="Email" onChange={handleEmailChange} fullWidth required />
                    </MKBox>
                    <MKBox mb={2}>
                      <TextField
                        fullWidth
                        label="Password"
                        value={password}
                        onChange={handlePasswordChange}
                        type={showPassword ? 'text' : 'password'}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {showPassword ? (
                                <VisibilityOff
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Visibility
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MKBox>
                    <MKBox display="flex" alignItems="center" ml={-1} style={{ marginLeft: "5px", marginTop: "10px", marginBottom: "-20px" }}>
                      <MKTypography variant="button" color="text">
                        {" "}
                        <MKTypography
                          component={Link}
                          to="/app/forgotpasswordemail"
                          variant="button"
                          color="info"
                          fontWeight="medium"
                          textGradient
                        >
                          Forgot Password ?
                        </MKTypography>
                      </MKTypography>
                    </MKBox>
                    {emailErrorMessage && (
                      <Grid item>
                        <MKTypography color="error" style={{ marginLeft: "5px", marginTop: "30px", fontSize: "13px", lineHeight: "1.2" }}>
                          {emailErrorMessage}
                        </MKTypography>
                      </Grid>
                    )}
                    <MKBox mt={4} mb={1}>
                      <MKButton variant="gradient" color="info" type="submit" onClick={handleSubmitClick} fullWidth>
                        sign in
                      </MKButton>
                    </MKBox>
                    <MKBox mt={3} mb={1} textAlign="center">
                      <MKTypography variant="button" color="text">
                        Don&apos;t have an account?{" "}
                        <MKTypography
                          component={Link}
                          to="/app/signup"
                          variant="button"
                          color="info"
                          fontWeight="medium"
                          textGradient
                        >
                          Sign up
                        </MKTypography>
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </MKBox>
        <MKBox width="100%" position="absolute" zIndex={2} bottom="1.625rem">
          <SimpleFooter light />
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default SignInBasic;
